<template>
  <div class="faka-add">
    <el-card class="form-card">
      <div slot="header" class="form-header">
        <span class="title">{{ isEdit ? '编辑商品' : '新增商品' }}</span>
        <el-button @click="goBack">返回列表</el-button>
      </div>
      
      <el-form 
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="120px"
        class="product-form"
      >
        <el-row :gutter="40">
          <!-- 左侧表单 -->
          <el-col :span="16">
            <div class="form-section">
              <h3 class="section-title">基本信息</h3>
              <el-form-item label="商品名称" prop="name">
                <el-input v-model="formData.name" placeholder="请输入商品名称"/>
              </el-form-item>
              
              <el-form-item label="商品分类" prop="categoryId">
                <el-select v-model="formData.categoryId" placeholder="请选择分类" style="width: 200px">
                  <el-option
                    v-for="item in categoryOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              
              <el-form-item label="商品价格" prop="price">
                <el-input-number 
                  v-model="formData.price"
                  :precision="2"
                  :step="0.1"
                  :min="0"
                  style="width: 200px"
                />
              </el-form-item>
            </div>

            <div class="form-section">
              <h3 class="section-title">商品描述</h3>
              <el-form-item label="商品描述" prop="description">
                <el-input
                  type="textarea"
                  v-model="formData.description"
                  :rows="4"
                  placeholder="请输入商品描述"
                />
              </el-form-item>
              
              <el-form-item label="使用说明" prop="instructions">
                <el-input
                  type="textarea"
                  v-model="formData.instructions"
                  :rows="4"
                  placeholder="请输入使用说明"
                />
              </el-form-item>
            </div>

          </el-col>

          <!-- 右侧表单 -->
          <el-col :span="8">
            <div class="form-section">
              <h3 class="section-title">商品图片</h3>
              <el-form-item label="商品图片">
                <el-upload
                  class="image-uploader"
                  :action="uploadUrl"
                  :headers="headers"
                  list-type="picture-card"
                  :file-list="imageList"
                  :on-success="handleImageSuccess"
                  :before-upload="beforeImageUpload"
                  :on-remove="onRemove"
                  multiple
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="image-tips">
                  <p>建议尺寸: 800x800px</p>
                  <p>支持格式: jpg, png</p>
                  <p>大小限制: 5MB</p>
                </div>
              </el-form-item>
            </div>

            <div class="form-section">
              <h3 class="section-title">商品设置</h3>
              <el-form-item label="展示时间">
                <el-switch
                  v-model="formData.showTime"
                  active-value="Y"
                  inactive-value="N"
                />
              </el-form-item>
              
              <el-form-item label="是否公开">
                <el-switch
                  v-model="formData.isOpen"
                  active-value="Y"
                  inactive-value="N"
                />
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <!-- 底部按钮 -->
        <div class="form-footer">
          <el-button type="primary" size="large" @click="submitForm">保存</el-button>
          <el-button size="large" @click="goBack">取消</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isEdit: false,
      formData: {
        name: '',
        categoryId: '',
        price: 0,
        description: '',
        instructions: '',
        images: [],
        cards: [],
        showTime: 'N',
        isOpen: 'Y'
      },
      imageList: [],
      categoryOptions: [
        { label: '游戏充值', value: '1' },
        { label: '会员账号', value: '2' },
        { label: '激活码', value: '3' },
        { label: '其他卡密', value: '4' }
      ],
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择商品分类', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入商品描述', trigger: 'blur' }
        ]
      },
      uploadUrl:  process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
      headers: {
        Authorization: localStorage.getItem('token')
      }
    }
  },

  methods: {
    async loadDetail(id) {
      try {
        const res = await this.$http2({
          url: `/klgeek/fakaProduct/${id}`,
          method: 'get'
        })
        this.formData = res.data
        // 处理图片列表
        if(res.data.images) {
          this.imageList = res.data.images.split(',').map(url => ({
            url,
            name: url.split('/').pop()
          }))
        }
      } catch(e) {
        this.$message.error('加载商品详情失败')
      }
    },

    handleImageSuccess(res, file,fileList) {
      console.log(fileList)
      file.url=res.data.originUrl
      // this.formData.images.push(res.data.originUrl)
      this.imageList=fileList;
    },
    onRemove(file,fileList){
      this.imageList=fileList;
    },
    beforeImageUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 5
      
      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    },

    handleBatchUpload(res) {
      if(res.cards && res.cards.length) {
        res.cards.forEach(card => {
          this.formData.cards.push({
            content: card
          })
        })
        this.$message.success(`成功导入 ${res.cards.length} 个卡密`)
      }
    },

    addCard() {
      this.formData.cards.push({
        content: ''
      })
    },

    removeCard(index) {
      this.formData.cards.splice(index, 1)
    },

    async submitForm() {
      this.$refs.form.validate(async valid => {
        if(valid) {
          try {
            let images=[]
            this.imageList.forEach(e=>{
              images.push(e.url);

            })
            this.formData.images=images.join(",")
            const method = this.isEdit ? 'put' : 'post'
            await this.$http2({
              url: '/klgeek/fakaProduct',
              method,
              data: this.formData
            })
            this.$message.success('保存成功')
            this.goBack()
          } catch(e) {
            this.$message.error('保存失败')
          }
        }
      })
    },

    goBack() {
      this.$router.push('/home/creation/faka')
    }
  },

  created() {
    const id = this.$route.query.id
    if(id) {
      this.isEdit = true
      this.loadDetail(id)
    }
  }
}
</script>

<style lang="scss" scoped>
.faka-add {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
  width: 100%;
  .form-card {
    max-width: 1400px;
    margin: 0 auto;
    
    .form-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      .title {
        font-size: 20px;
        font-weight: 500;
      }
    }
  }
  
  .product-form {
    padding: 20px 0;
    
    .form-section {
      background: #fff;
      padding: 20px;
      border-radius: 8px;
      margin-bottom: 20px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
      
      .section-title {
        font-size: 16px;
        font-weight: 500;
        color: #303133;
        margin: 0 0 20px;
        padding-left: 10px;
        border-left: 4px solid #409EFF;
      }
      
      &:last-child {
        margin-bottom: 0;
      }
    }
    
    .card-list {
      .card-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        
        .el-input {
          margin-right: 10px;
        }
        
        .el-button {
          color: #f56c6c;
          
          &:hover {
            background: rgba(245,108,108,0.1);
          }
        }
      }
      
      .card-actions {
        display: flex;
        gap: 10px;
        margin-top: 20px;
      }
    }
    
    .image-uploader {
      :deep(.el-upload--picture-card) {
        width: 150px;
        height: 150px;
        line-height: 150px;
      }
      
      .image-tips {
        margin-top: 10px;
        color: #909399;
        font-size: 12px;
        line-height: 1.8;
      }
    }
  }
  
  .form-footer {
    text-align: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
    
    .el-button {
      min-width: 120px;
      margin: 0 10px;
    }
  }
}
</style> 